import React, { useState } from 'react'
import Header from '../../master/SideBar'
import Nav from '../../master/NavBar'
import { useNavigate } from 'react-router-dom';
import StudentHeader from './StudentHeader';
import { imgBaseUrl } from '../../../api/api';

const AddmissionForm = () => {
    const [loading, setLoading] = useState(false);
    const instituteData = JSON.parse(localStorage.getItem("setting")) || {};
    const navigate = useNavigate();

      const handlePrint = () => {
    const printContent = document.getElementById("admissionForm").innerHTML;
    const WinPrint = window.open("", "", "width=900,height=650");
    WinPrint.document.write(`
      <html>
        <head>
          <title>Admission Form</title>
          <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet">
          <style>
            body { font-family: Arial, sans-serif; background: #fff; color: #000; }
            .a4-sheet { width: 210mm; min-height: 297mm; margin: auto; padding: 20mm; border: 2px solid #000; background: #fff; }
            .form-header { text-align: center; margin-bottom: 20px; }
            .form-header img { height: 80px; margin-bottom: 10px; }
            .form-title { font-size: 22px; font-weight: bold; text-decoration: underline; }
            .section-title { font-weight: bold; margin: 25px 0 15px 0; background: #f1f1f1; padding: 8px 10px; border-left: 4px solid #7306c6; }
            .signature-box { border-top: 1px solid #000; margin-top: 60px; padding-top: 10px; text-align: center; }
            .underline-field { display:inline-block; border-bottom:1px dotted #000; min-width:200px; padding:0 4px; }
            @media print { body { -webkit-print-color-adjust: exact; } .a4-sheet { border: none; margin: 0; padding: 10mm; } }
          </style>
        </head>
        <body>${printContent}</body>
      </html>
    `);
    WinPrint.document.close();
    WinPrint.print();
  };
    return (
        <>

            {loading && (
                <div
                    className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
                    style={{ zIndex: 9999 }}
                >
                    <div className="sk-chase sk-primary display-1">
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                    </div>
                </div>
            )}
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <div className="no-print">
                        <Header />
                    </div>
                    <div className="layout-page">
                        <div className="no-print">
                            <Nav />
                        </div>
                        
                            <div className="container-fluid mt-2">
                                <div className="row custom-scroll-layout">
                               
                               <div className="col-md-2 left-pane">
                                 <StudentHeader data={'Student Portal'}/>
                               </div>
                                <div className="col-md-10 right-pane">
                                    <button className='btn btn-sm btn-primary mt-2 ms-6' onClick={handlePrint}>print</button>
                                <div id="admissionForm" className="container my-2">
                                    <div
                                        className="card shadow-lg rounded-2xl p-4"
                                        style={{ maxWidth: "800px", margin: "0 auto", fontSize: "14px" }}
                                    >
                                        {/* Header */}
                                        <div className="text-center border-b pb-3 mb-3">
                                            <img
                                                src={
                                                    instituteData?.logo_img
                                                        ? `${imgBaseUrl+ instituteData.logo_img}`
                                                        : "/files/logo.png"
                                                }
                                                alt="Logo"
                                                style={{ height: "60px" }}
                                            />
                                            <h4 className="mt-2">{instituteData?.name || "School Name"}</h4>
                                            <p className="mb-1">
                                                <strong>Address:</strong>{" "}
                                                <span>
                                                    {instituteData?.village}{" "}
                                                    {instituteData?.district} ({instituteData?.state})
                                                </span>
                                            </p>
                                            <p className="mb-0">
                                                <strong>Phone:</strong>{" "}
                                                <span>{instituteData?.mobile}</span>{" "}
                                                {instituteData?.secondary_mobile && (
                                                    <span>, {instituteData.secondary_mobile}</span>
                                                )}
                                                {" | "}
                                                <strong>Email:</strong>{" "}
                                                <span>{instituteData?.email}</span>
                                            </p>
                                            <div className="fw-bold text-lg mt-2">Admission Form</div>
                                        </div>

                                        {/* Student Info */}
                                        <div className="fw-bold border-bottom mb-2 text-primary">Student Information</div>
                                        <div className="row mb-2">
                                            <div className="col-6">
                                                Full Name:{" "}
                                                <span className="underline-field"></span>
                                            </div>
                                            <div className="col-6">
                                                Father&apos;s Name:{" "}
                                                <span className="underline-field"></span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-6">
                                                Mother&apos;s Name:{" "}
                                                <span className="underline-field"></span>
                                            </div>
                                            <div className="col-6">
                                                Date of Birth:{" "}
                                                <span className="underline-field"></span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-6">
                                                Gender: <span className="underline-field"></span>
                                            </div>
                                            <div className="col-6">
                                                Category:{" "}
                                                <span className="underline-field"></span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-12">
                                                Address:{" "}
                                                <span className="underline-field" style={{ minWidth: "400px" }}>

                                                </span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-6">
                                                Mobile No:{" "}
                                                <span className="underline-field"></span>
                                            </div>
                                            <div className="col-6">
                                                Aadhar No:{" "}
                                                <span className="underline-field"></span>
                                            </div>
                                        </div>

                                        {/* Course Info */}
                                        <div className="fw-bold border-bottom mt-3 mb-2 text-primary">Course Information</div>
                                        <div className="row mb-2">
                                            <div className="col-6">
                                                Class Applied For:{" "}
                                                <span className="underline-field">

                                                </span>
                                            </div>
                                            <div className="col-6">
                                                Batch Timing:{" "}
                                                <span className="underline-field">

                                                </span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-6">
                                                Date of Admission:{" "}
                                                <span className="underline-field"></span>
                                            </div>
                                            <div className="col-6">
                                                Admission No:{" "}
                                                <span className="underline-field"></span>
                                            </div>
                                        </div>

                                        {/* Transport Info */}
                                        <div className="fw-bold border-bottom mt-3 mb-2 text-primary">Transport Details</div>
                                        <div className="row mb-2">
                                            <div className="col-6">
                                                Transport Facility Required:{" "}
                                                <span className="underline-field">

                                                </span>
                                            </div>
                                            <div className="col-6">
                                                Route No:{" "}
                                                <span className="underline-field">

                                                </span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-12">
                                                Pickup Point:{" "}
                                                <span className="underline-field" style={{ minWidth: "300px" }}>

                                                </span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-12">
                                                Parent Contact:{" "}
                                                <span className="underline-field"></span>
                                            </div>
                                        </div>

                                        {/* Declaration */}
                                        <div className="fw-bold border-bottom mt-3 mb-2 text-primary">Declaration</div>
                                        <p style={{ fontSize: "13px" }}>
                                            I hereby declare that the above information is true and correct to
                                            the best of my knowledge. I agree to abide by the rules and
                                            regulations of{" "}
                                            <span className="underline-field">
                                                {instituteData?.name}
                                            </span>
                                            .
                                        </p>

                                        {/* Signatures */}
                                        <div className="row mt-4 text-center">
                                            <div className="col-4 border-top pt-2">Student’s Signature</div>
                                            <div className="col-4 border-top pt-2">Parent’s Signature</div>
                                            <div className="col-4 border-top pt-2">Authorized Signatory</div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                                

                                </div>


                            </div>
                      
                    </div>
                </div>
            </div>

        </>
    )
}

export default AddmissionForm
